<template>
  <div class="lottery-kind">
    <Card
      :bordered="false"
      shadow
    >
      <lottery-kind-setting
        @ResetList="lotplt"
        :modal.sync="settingModal"
        :stateModal="stateModal"
        :refergamearr="refergamearr"
      ></lottery-kind-setting>
      <Row
        type="flex"
        align="middle"
      >
        <lidaTable
          :propscolumns="columns"
          :data="filterData"
          :propsPageSize="50"
          :sortStatus="false"
        >
          <template v-slot:headerSelect>
            <Button
              v-if="modifyState"
              type="primary"
              @click="clickModal(1)"
              class="mr-2"
            >
              新增自开彩
            </Button>
            <span
              v-for="it in filterConditionArr"
              :key="it.id"
              style="width: 130px"
            >
              <span class="mx-2">{{ it.text }}</span>
              <Select v-model="filterCondition[it.id]">
                <Option
                  v-for="(item, idx) in it.arr"
                  :value="item.val"
                  :key="idx"
                >{{ item.text }}</Option>
              </Select>
            </span>
          </template>
        </lidaTable>
      </Row>
      <divider />
    </Card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Utile } from 'utils';
import { markSates } from '@/plugins/utils/game-id-filter.js';
import filterConditions from '@/mixins/filter-conditions.js'
import GameGroupMethods from 'utils/game-group-methods.js'
import siteGroup from 'utils/site-group.js'
const gameGroupMethods = new GameGroupMethods()
export default {
  name: 'lottery-kind-list',
  mixins: [filterConditions],
  components: {
    LotteryKindSetting: () => import(/* webpackChunkName: "lottery-kind" */ './components/LotteryKindSetting'),
  },
  data () {
    return {
      settingModal: false,
      stateModal: {
        state: '1',
        listid: null
      },
      datatb: [],
      upidop: 99,
      refergamearr: [],
      filterCondition: {
        hfl: 999,
        ismy: 999,
        catenaId: 999,
        siteId: 999
      },
    };
  },
  computed: {
    ...mapGetters(['getpermission']),
    modifyState () { // 修改狀態
      return this.getpermission.gameswitch[1] == 1
    },
    filterConditionArr () {
      let result = [
        { id: 'siteId', val: this.filterCondition.idop, text: '站别类型', arr: this.siteIdArr },
        { id: 'hfl', val: this.filterCondition.hfl, text: '高低频', arr: this.isLowArr },
        { id: 'ismy', val: this.filterCondition.ismy, text: '彩种类型', arr: this.ismyArr },
        { id: 'catenaId', val: this.filterCondition.catenaId, text: '彩种系列', arr: this.catenaIdArr },
      ]
      return result
    },
    filterData () {
      let filterData = []
      let obj = {
        hfl: this.filterCondition.hfl == 999 ? undefined : this.filterCondition.hfl,
        ismy: this.filterCondition.ismy == 999 ? undefined : this.filterCondition.ismy,
        catenaId: this.filterCondition.catenaId == 999 ? undefined : this.filterCondition.catenaId,
        siteId: this.filterCondition.siteId == 999 ? undefined : this.filterCondition.siteId,
      }
      for (let key in obj) { //先删除不需要的条件
        if (obj[key] == undefined) delete obj[key]
      }
      const conditionArr = Object.keys(obj)
      if (conditionArr.length == 0) return this.datatb
      conditionArr.forEach((cit, cidx) => {
        if (cidx == 0) {
          filterData = this.datatb.filter(it => it[cit] == obj[cit])
        } else {
          filterData = filterData.filter(it => it[cit] == obj[cit])
        }
      })
      return filterData
    },
    columns () {
      const result = {
        queue: {
          title: "排序",
          key: 'queue',
          align: 'center',
          sortable: 'custom',
        },
        siteId: {
          title: "站别类型",
          key: 'siteId',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            const find = siteGroup.items[params.row.siteId]
            return h("span", find)
          }
        },
        hfltext: {
          title: "高低频",
          key: 'hfltext',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h("span", params.row.hfltext)
          }
        },
        hfltext: {
          title: "高低频",
          key: 'hfltext',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h("span", params.row.hfltext)
          }
        },
        ismy: {
          title: '彩种类型',
          key: 'ismy',
          align: 'center',
          sortable: true,
          render: (h, parmas) => {
            return h('p', parmas.row.ismy == 1 ? '自开彩' : '官彩')
          },
        },
        catenaId: {
          title: "彩种系列",
          key: 'catenaId',
          align: 'center',
          sortable: 'custom',
          render: (h, params) => {
            return h("span", gameGroupMethods.catenaGroup(params.row.catenaId))
          }
        },
        gamename: {
          title: "彩种名称",
          key: 'gamename',
          align: 'center',
          sortable: 'custom',
        },
        openInterval: {
          title: '开关盘时间',
          key: 'openInterval',
          align: 'center',
          render: (h, params) => {
            if (!params.row.openInterval) return
            let timeArr = params.row.openInterval.split(',')
            let domArr = timeArr.map((it, idx) => {
              return (idx % 2) ? h(`span`, it) : h(`span`, `${it}-`)
            })
            if (domArr.length < 3) return h('p', domArr)
            else {
              let domArr2 = Utile.chunk(domArr, 2)
              let pArr = domArr2.map(it => h(`p`, it))
              return h('div', pArr)
            }
          }
        },
        bettime: {
          title: '下注时间',
          key: 'bettime',
          align: 'center',
          render: (h, params) => {
            let bettime = params.row.bettime
            if (!bettime) return
            let hour;
            let minute;
            let second;
            let timeArr;
            if (bettime == 86400) {
              const dayTimeArr = params.row.openInterval.split(',')
              const day1 = dayTimeArr[0].split(':').map(it => Number(it))
              const day2 = dayTimeArr[1].split(':').map(it => Number(it))
              timeArr = [
                Math.abs(day1[0] - day2[0]),
                Math.abs(day1[1] - day2[1]),
                Math.abs(day1[2] - day2[2]),
              ]
            } else {
              timeArr = [
                Math.floor(bettime / 3600),
                Math.floor(bettime % 3600 / 60),
                Math.floor(bettime % 3600 % 60),
              ]
            }
            hour = timeArr[0] ? `${timeArr[0]}小時` : ''
            minute = timeArr[1] ? `${timeArr[1]}分` : ''
            second = timeArr[2] ? `${timeArr[2]}秒` : ''
            return h('p', hour + minute + second)
          }
        },
        imgurl: {
          title: '彩种LOGO',
          key: 'imgurl',
          align: 'center',
          render: (h, params) => {
            let migcash = new Date().getTime()
            return h('img', {
              attrs: {
                src: `${process.env.VUE_APP_IMAGE_URL}/img/` + params.row.imgurl + ".jpge?" + migcash
              },
              style: {
                maxWidth: '75px',
                marginTop: '0.5rem'
              },
              ref: params.row.imgurl,
              on: {
                error: (event) => {
                  event.target.src = require("@/assets/img/defaultIcon.png")
                }
              }
            })
          },
        },
        action: {
          title: "操作",
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h("a", {
              on: {
                "click": () => {
                  this.clickModal(2, params.row.lotid)
                }
              }
            }, '修改')
          }
        }
      }
      if (!this.modifyState) delete result.action
      return result
    },

  },
  created () {
    this.lotplt();
  },
  methods: {
    clickModal (state, id) {
      this.settingModal = !this.settingModal
      this.stateModal.state = state
      this.stateModal.listid = id
    },
    async lotplt () {
      try {
        let res = await this.$axios.gameLobby.listData()
        if ('status' in res && res.status === 0) return
        this.datatb = res.map(it => {
          it.hfltext = it.hfl === 1 ? '低頻彩' : '高頻彩'
          it.isLow = it.hfl === 1 ? 1 : 0
          return it
        }).sort((a, b) => a.queue - b.queue)
        this.refergamearr = res.map(it => {
          if (it.ismy) {
            return {
              gamename: it.gamename,
              lotid: it.lotid,
              catenaId: it.catenaId,
              openInterval: it.openInterval,
              bettime: it.bettime
            }
          }
        }).filter(it => it)
      } catch (error) {
        console.error(error);
        this.$Message.error('网路异常');
      }
    },
  }
};
</script>
<style lang="scss">
.lottery-kind {
  span {
    .ivu-select {
      width: auto;
    }
  }
}
</style>
